import { render, staticRenderFns } from "./ShipperLocationListDataTable.vue?vue&type=template&id=22a3d13e&"
import script from "./ShipperLocationListDataTable.vue?vue&type=script&lang=js&"
export * from "./ShipperLocationListDataTable.vue?vue&type=script&lang=js&"
import style0 from "./ShipperLocationListDataTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports